import { Router } from '@reach/router';
import React, { FC } from 'react';

type Props = {
  basepath?: string;
  className?: string;
};

export const Wizard: FC<Props> = ({ basepath, children, className }) => {
  return (
    <Router basepath={basepath} className={className}>
      {children}
    </Router>
  );
};
